<header>
    <div class="h-[80px]" [style.backgroundColor]="'var(--pax-header-mobile-background)'">
        <div class="flex justify-end items-center px-6 h-full">
            <!-- Logo -->
            <a routerLink="/" class="flex items-center">
                <img src="/assets/logo.svg" alt="Pax Logo" class="h-[30px]" />
            </a>
        </div>
    </div>
</header>
